export default __webpack_public_path__ + "static/media/IMG21.5371fcca.jpeg";